<template>
    <section class="section section-numbers">
        <div class="container">
            <div class="row">
                <h2 class="numbers-heading">Company statistics</h2>
                <div class="number col-12 col-md-4">
                    <i class="fa fa-compass"></i>
                    <p class="number-text">million tons of cargo</p>
                    <p class="number-number">{{ cargoString }}</p>
                </div>
                <div class="number col-12 col-md-4">
                    <i class="fa fa-signal"></i>
                    <p class="number-text">billion USD turn over</p>
                    <p class="number-number">{{ turnoverString }}</p>
                </div>
                <div class="number col-12 col-md-4">
                    <i class="fa fa-ship"></i>
                    <p class="number-text">ships</p>
                    <p class="number-number">{{ shipsString }}</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default ({
    name: "Numbers",
    data() {
        return {
            cargoString: null,
            turnoverString: null,
            shipsString: null
        }
    },
    computed: {
        numbersData() {
            return this.$store.state.numbers;
        }
    },
    watch: {
        numbersData() {
            this.animateNumbers();
        }
    },
    mounted() {
        if (this.numbersData) {
            this.animateNumbers();
        }
    },
    methods: {
        animateNumbers() {
            let divisions = {},
                numbers = {
                    cargo: 0,
                    turnover: 0,
                    ships: 0
                },
                numberOfIterations = 30,
                j = 0;

            divisions.cargo = this.numbersData.cargo / numberOfIterations;

            divisions.turnover = this.numbersData.turnover / numberOfIterations;
            divisions.ships = this.numbersData.ships / numberOfIterations;

            let intervalFunction = setInterval(() => {
                j++;

                numbers.cargo += divisions.cargo;
                this.cargoString = numbers.cargo.toFixed(1);

                numbers.turnover += divisions.turnover;
                this.turnoverString = numbers.turnover.toFixed(2);

                numbers.ships += divisions.ships;
                this.shipsString = numbers.ships.toFixed(0);

                if (j === numberOfIterations) {
                    clearInterval(intervalFunction);
                }
            }, 100);
        }
    }
})
</script>

<style scoped>
.section-numbers {
    background-color: #26828E;
    color: #FFFFFF;
}

.numbers-heading {
    position: fixed;
    top: -10rem;
}

.section-numbers .number {
    text-align: center;
}

.section-numbers .fa {
    color: #28284e;
    font-size: 3.5em;
}

.section-numbers .number-text {
    margin: 1.7em auto 0;
}

.section-numbers .number-number {
    font-size: 5em;
    font-weight: 700;
}
</style>
